export const tableData = [{
  name: "PSOE-A",
  value: 33,
  color: "#E30613",
  id: "22",
  percent: 27.95,
  votes: 1009243
}, {
  name: "PP",
  value: 26,
  color: "#03A2E6",
  id: "20",
  percent: 20.75,
  votes: 749275
}, {
  name: "Cs",
  value: 21,
  color: "#EB6109",
  id: "6",
  percent: 18.27,
  votes: 659631
}, {
  name: "ADELANTE ANDALUCÍA",
  value: 17,
  color: "#05C97F",
  id: "1",
  percent: 16.18,
  votes: 584040
}, {
  name: "VOX",
  value: 12,
  color: "#68BD00",
  id: "30",
  percent: 10.97,
  votes: 395978
}];